import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.64671 4.01V12.3527C3.64662 12.5909 3.69348 12.8268 3.78462 13.047C3.87575 13.2671 4.00936 13.4671 4.17782 13.6356C4.34629 13.804 4.5463 13.9376 4.76642 14.0288C4.98654 14.1199 5.22247 14.1668 5.46071 14.1667H10.5394C11.0203 14.1667 11.4815 13.9756 11.8216 13.6356C12.1617 13.2955 12.3527 12.8343 12.3527 12.3533V4.00934M2.19604 4.01H13.804",
      stroke: "#303333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.82349 4.01001V2.92134C5.82349 2.77841 5.85165 2.63688 5.90637 2.50483C5.96109 2.37278 6.04129 2.25281 6.14239 2.15178C6.24349 2.05074 6.36351 1.97061 6.49559 1.91597C6.62767 1.86133 6.76922 1.83326 6.91215 1.83334H9.08815C9.23109 1.83326 9.37264 1.86133 9.50472 1.91597C9.6368 1.97061 9.75682 2.05074 9.85792 2.15178C9.95902 2.25281 10.0392 2.37278 10.0939 2.50483C10.1487 2.63688 10.1768 2.77841 10.1768 2.92134V4.01001M6.54949 11.328V7.70201M9.45149 11.328V7.70201",
      stroke: "#303333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }